import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const HowItWorksFeaturesContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.gray};
  .container {
    padding-top: 95px;
    padding-bottom: 95px;
    h2 {
      color: ${colors.blueDark};
      margin-bottom: 40px;
      text-align: center;
    }
    .how-features-wrapper {
      max-width: 1380px;
      margin: 0 auto;
      a {
        color: ${colors.blueDark};
      }
      .how-features-item {
        margin-bottom: 14px;
        color: ${colors.blueDark};
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .container {
      padding-top: 36px;
      padding-bottom: 55px;
      h2 {
        text-align: left;
      }
      .how-features-wrapper {
        ol {
          padding-left: 22px;
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
